import routeBuilder from './routes';
const view = {
  layout: 'Dashboard',
  routeBuilder,
};
export default view;
